<template>
  <div class="position-translate-center">
    <div class="col-auto">
      <div class="text-center px-4">
        <h4>アクセスできません</h4>
        <p class="text-medium-emphasis mb-0">
          URLをご確認のうえ、再度アクセスしてください。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ErrorInaccessible",
}
</script>
